<template>
  <div class="card card-form sign-upIn _control_panel">
    <div class="card-header">
      <div class="card-title w-auto">Control Panel</div>
    </div>
    <div class="card-body h-auto">
      <div class="base-form h-100 d-flex justify-content-between flex-column">
        <div class="input-group _group-xl mb-3">
          <span class="input-group-text no-wrap control-label">
            <i class="fas fa-calendar-alt me-2 text-primary"></i> Invoice Terms (days)
          </span>
          <select v-model="invoice_term" class="form-select" required>
            <option value="" selected disabled>Select</option>
            <option v-for="day in 31" :value="day" :key="day">
              {{ day }}
            </option>
          </select>
        </div>

        <div class="input-group _group-xl mb-3">
          <span class="input-group-text no-wrap control-label">
            <i class="fas fa-file-invoice me-2 text-info"></i> Quotation Terms (days)
          </span>
          <select v-model="quotation_term" class="form-select" required>
            <option value="" selected disabled>Select</option>
            <option v-for="day in 31" :value="day" :key="day">
              {{ day }}
            </option>
          </select>
        </div>

        <!-- <div class="input-group _group-xl mb-3">
          <span class="input-group-text no-wrap control-label">
            <i class="fas fa-money-bill-wave me-2 text-success"></i> Default Currency
          </span>
          <select v-model="currency_id" class="form-select" required>
            <option value="" selected disabled>Select</option>
            <option
              v-for="option in currency_options"
              :value="option.id"
              :key="option.id"
            >
              {{ option.name }}
            </option>
          </select>
        </div> -->
      </div>

      <div class="form-footer d-flex align-items-end mb-2">
        <button type="submit" role="button" class="btn btn-success float-end mb-4" @click="saveData">
          Update
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { CURRENCY_LIST } from "@/config/url";

export default {
  name: "ControlPanel",
  data() {
    return {
      loadingInstance: null,
      invoice_term: "",
      quotation_term: "",
      currency_id: "",
      currencies: [],
      initial_currency_id: "",
    };
  },
  computed: {
    currency_options() {
      if (this.currencies) {
        return this.currencies.map((v) => {
          return {
            id: v.id,
            name: v.name,
          };
        });
      }
      return [];
    },
  },
  async mounted() {
    await this.fetchCurrencies();
    this.getData();
  },
  methods: {
    showLoading() {
      this.loadingInstance = this.$loading({
        lock: true,
        text: "Loading",
        background: "rgba(0, 0, 0, 0.7)",
        fullscreen: true,
      });
    },
    hideLoading() {
      if (this.loadingInstance) {
        this.loadingInstance.close();
      }
    },
    async fetchCurrencies() {
      try {
        const res = await this.axios.get(CURRENCY_LIST);
        this.currencies = res.data.response;
      } catch (err) {
        console.log(err);
      }
    },
    getData() {
      this.showLoading();
      this.$store
        .dispatch("setting/getTermsDetails")
        .then((res) => {
          if (res.data.status == 1) {
            this.invoice_term = res.data.response.invoice_days
              ? res.data.response.invoice_days
              : 30;
            this.quotation_term = res.data.response.quotation_days
              ? res.data.response.quotation_days
              : 14;

            this.currency_id = this.initial_currency_id = this.$store.getters[
              "auth/getUserData"
            ].currency_id;
          } else {
            // Show API message if available, otherwise fallback
            const errorMsg =
              res.data.message?.length > 0
                ? Array.isArray(res.data.message)
                  ? res.data.message.join("\n")
                  : res.data.message
                : "Something went wrong. Please try again.";

            this.$toast.error(errorMsg);
            throw new Error(errorMsg);
          }
        })
        .catch((err) => {
          console.log(err);
          // Optional: fallback toast in case no error was handled above
          if (!err.message) {
            this.$toast.error("Something went wrong. Please try again.");
          }
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    saveData() {
      this.showLoading();
      let form_data = new FormData();
      form_data.append("invoice_days", this.invoice_term);
      form_data.append("quotation_days", this.quotation_term);

      const requests = [];
      requests.push(this.$store.dispatch("setting/saveTermDetails", form_data));

      if (this.currency_id !== this.initial_currency_id) {
        let form_data_currency = new FormData();
        form_data_currency.append("currency_id", this.currency_id);
        requests.push(this.$store.dispatch("auth/updateCurrency", form_data_currency));
      }

      Promise.all(requests)
        .then((results) => {
          const termRes = results[0]; // Term details result (axios response)
          let allSuccess = false;
          let hasCurrencyUpdate = requests.length > 1;

          if (termRes && termRes.data && termRes.data.status == 1) {
            allSuccess = true;
          }

          if (hasCurrencyUpdate) {
            const currencyRes = results[1]; // updateCurrency result (response.data)
            if (!currencyRes || currencyRes.status != 1) {
              allSuccess = false;
            }
          }

          if (allSuccess) {
            this.$toast.success("Settings updated successfully.");
            if (this.currency_id !== this.initial_currency_id) {
              this.initial_currency_id = this.currency_id;

              // Fallback manual update to Vuex
              this.$store.commit("auth/updateUserSettings", {
                currency_id: this.currency_id
              });
            }
          } else {
            throw new Error("Some settings failed to update.");
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toast.error("Something went wrong. Please try again.");
        })
        .finally(() => {
          this.hideLoading();
        });
    },
  },
};
</script>

<style scoped>
.control-label {
  min-width: 230px !important;
  max-width: 230px !important;
  width: 230px !important;
}
</style>
